import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import _ from 'lodash';

import {
  resetState,
  sendFormRequest,
  selectRequestState,
  changeFieldToken,
  selectMessage
} from 'mt-react-common/modules/users/common/reducers/forms/confirmForm';
import qs from 'qs';
import BigPreLoader from '../../../Common/PreLoaders/BigPreLoader';

const signInFormRM = 'usersModule.forms.confirmChangeEmailForm';

class ConfirmChangeEmail extends Component {
  componentDidMount() {
    const token = _.get(qs.parse(this.props.location.search.slice(1)), 'token');
    this.props.resetState();
    this.props.changeFieldToken(token);
    this.props.sendFormRequest();
  }

  render() {
    if (this.props.requestState.hasInProgress) {
      return <BigPreLoader />;
    }
    return (
      <div
        className="container page-container_sticky"
        style={{
          padding: '20px'
        }}
      >
        <article
          className={`panel ${
            this.props.requestState.hasSuccessQuery
              ? 'panel-success'
              : 'panel-danger'
          }`}
        >
          <div className="panel-heading text-center">
            <h3 className="panel-title">Подтверждение изменения почты</h3>
          </div>
          <div className="panel-body">
            <p>
              {this.props.selectMessage} Для перехода на сайт нажмите на{' '}
              <Link to="/">ссылку</Link>.
            </p>
          </div>
        </article>
      </div>
    );
  }
}

ConfirmChangeEmail.propTypes = {
  resetState: PropTypes.func.isRequired,
  sendFormRequest: PropTypes.func.isRequired,
  changeFieldToken: PropTypes.func.isRequired,

  requestState: PropTypes.shape({
    hasInProgress: PropTypes.bool.isRequired,
    hasSuccessQuery: PropTypes.bool
  }).isRequired,
  selectMessage: PropTypes.string.isRequired,

  location: PropTypes.shape().isRequired
};

const mapStateToProps = state => ({
  requestState: selectRequestState(state, signInFormRM),
  selectMessage: selectMessage(state, signInFormRM)
});

const mapDispatchToProps = dispatch => ({
  resetState: () => dispatch(resetState(signInFormRM)),
  sendFormRequest: () => dispatch(sendFormRequest(signInFormRM)),
  changeFieldToken: value => dispatch(changeFieldToken(signInFormRM, value))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ConfirmChangeEmail)
);



// WEBPACK FOOTER //
// ./src/components/UserAccount/Confirms/ConfirmChangeEmail/ConfirmChangeEmail.js